













































































import { createComponent, ref, onMounted, computed, watch, SetupContext, reactive } from '@vue/composition-api'
import { getFileIcon, formatFileSize } from '@/helpers/common'
import { UNZIP_COMPRESS_STATUS_CODE } from '@/constant'
import {
    unzipOrCompressTaskDelete,
    unzipOrCompressTaskRetry,
    UnzipListItem,
    cancelCompressOrUnzip,
} from '@/service/public'
import { Message, MessageBox } from '@heytap/cook-ui'

export default createComponent({
    name: 'UnZipList',
    props: {
        dialogData: {
            type: Array,
            default: res => {
                return []
            },
        },
        isShowLoad: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, setupContext: SetupContext) {
        const statusMap = {
            1: '解压中',
            2: '解压成功',
            3: '失败（不可重试）',
            4: '失败（可重试）',
        }
        const reStart = async (row: UnzipListItem) => {
            const res = await unzipOrCompressTaskRetry(row.id)
            if (res.code === 0) {
                setupContext.emit('onOperate')
            } else {
                Message.error(res.desc || '重试失败')
            }
        }
        const remove = async (row: UnzipListItem) => {
            const res = await unzipOrCompressTaskDelete(row.id)
            if (res.code === 0) {
                setupContext.emit('onOperate')
            } else {
                Message.error(res.desc || '删除失败')
            }
        }
        const cancel = async (row: UnzipListItem) => {
            MessageBox.confirm(`确认取消解压${row.file.name}吗？`, '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(async () => {
                    const res = await cancelCompressOrUnzip(row.id)
                    if (res.code === 0) {
                        setupContext.emit('onOperate')
                    }
                })
                .catch(() => {
                    //
                })
        }
        return {
            getFileIcon,
            formatFileSize,
            reStart,
            remove,
            cancel,
            statusMap,
            UNZIP_COMPRESS_STATUS_CODE,
        }
    },
})
